<body class="ltr leftmenu">
    <form autocomplete="off" novalidate >
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="col-md-8 padding">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/approval.png" class="mh-45px pb-2">
                                            <div class="">
                                                <h4 class="main-content-label mb-1"><b>
                                                    Notification/Announcements
                                                    </b></h4>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Notification/Announcements Data
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="mt-2 mb-2">
                                    <div class="row clearfix mt-3">
                                        
                                        <div class="row clearfix">
                                            <div class="col-sm-12">
                                                <div  class="table-responsive min mt-4 ">
                                                    <div class="container">
                                                        <table class="table  table-bordered text-nowrap text-left">
                                                            <thead>
                                                                <tr>
                                                                    <th class="f600" style="width: 5%;">
                                                                        Sr No
                                                                    </th>
                                                                    <th class="f600">
                                                                        Date
                                                                    </th>
                                                                    <th class="f600" style="width: 15%;">
                                                                        Notification Title
                                                                    </th>
                                                                    <th class="f600" style="width: 25%;">
                                                                        Notification Description
                                                                    </th>
                                                                    <th class="f600" style="width: 15%;">
                                                                        Document Name
                                                                    </th>
                                                                    <th class="f600" style="width: 5%;">
                                                                        View
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody id="table_data">
                                                                <!-- examSemList -->
                                                                <tr *ngFor="let data of NotificationsData; let i = index; let isLast = last">
                                                                    <td style="width: 5%;" *ngIf="shouldMergeRows(i, 'NotTitle')" [attr.rowspan]="getRowSpan(i, 'NotTitle')">
                                                                        {{ getSrNo(i) }}
                                                                    </td>
                                                                    <td style="width: 15%;" *ngIf="shouldMergeRows(i, 'NotTitle')" [attr.rowspan]="getRowSpan(i, 'NotTitle')">
                                                                        {{convertUTCToIST(data.CreatedAt)}}
                                                                    </td>
                                                                    <td  style="width: 15%;" *ngIf="shouldMergeRows(i, 'NotTitle')" [attr.rowspan]="getRowSpan(i, 'NotTitle')">
                                                                        {{data.NotTitle}}
                                                                    </td>
                                                                    <td  style="width: 25%;" *ngIf="shouldMergeRows(i, 'NotDesc')" [attr.rowspan]="getRowSpan(i, 'NotDesc')">
                                                                        {{data.NotDesc}}
                                                                    </td>
                                                                    <td style="width: 15%;">
                                                                        {{data.DocName != "" ? data.DocName : "No Document Name"}}
                                                                    </td>
                                                                    <td  style="width: 5%;" (click)="showbase64(data)">
                                                                        <a *ngIf="data.DocUpload != ''"><label class="blue_col">View</label></a>
                                                                        <a *ngIf="data.DocUpload == ''"><label>No Document</label></a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                        
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>